import { palette } from '@dev/ee-components';
import styled from 'styled-components';

export const Step5ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Step5ContentColumns = styled.div`
    display: grid;
    grid-template-columns: 1fr minmax(0, 1fr);
    gap: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid ${palette.gray[3]};
`;

export const Step5ContentScreenshotWrapper = styled.div`
    height: 372px;
    border-radius: 20px;
    border: 1px solid ${palette.gray[2]};
    position: relative;
    background-color: #fff;

    img {
        width: 100%;
        height: 100%;
        border-radius: 20px;
        object-fit: cover;
        object-position: top;
    }
`;

export const Step5ContentScreenshotHover = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
    top: 0;
    width: 100%;
    height: 372px;
    position: absolute;
    opacity: 0;
    border-radius: 20px;

    &:hover {
        transition: opacity 0.5s ease-in-out;
        opacity: 1;
        background-color: rgba(45, 47, 122, 0.24);
    },
`;


export const Step5ContentFields = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const Step5ContentField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Step5ContentAudience = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    word-wrap: anywhere;
`;
